import React from "react";
import SyncLoader from "react-spinners/SyncLoader";

const CustomLoader = ({ loading }) => {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="text-center mt-4">
            <SyncLoader size={15} color={"#0061f2"} loading={loading} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomLoader;
